import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f1a5ac0c = () => interopDefault(import('..\\src\\pages\\about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _3c15d882 = () => interopDefault(import('..\\src\\pages\\admin\\index.vue' /* webpackChunkName: "pages/admin/index" */))
const _18db131a = () => interopDefault(import('..\\src\\pages\\car\\index.vue' /* webpackChunkName: "pages/car/index" */))
const _3497d490 = () => interopDefault(import('..\\src\\pages\\guide.vue' /* webpackChunkName: "pages/guide" */))
const _0b6de7be = () => interopDefault(import('..\\src\\pages\\invoice\\index.vue' /* webpackChunkName: "pages/invoice/index" */))
const _49e18a7d = () => interopDefault(import('..\\src\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _7f18d279 = () => interopDefault(import('..\\src\\pages\\mem\\index.vue' /* webpackChunkName: "pages/mem/index" */))
const _304ba233 = () => interopDefault(import('..\\src\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _87d36d64 = () => interopDefault(import('..\\src\\pages\\policy.vue' /* webpackChunkName: "pages/policy" */))
const _554b9b9c = () => interopDefault(import('..\\src\\pages\\report\\index.vue' /* webpackChunkName: "pages/report/index" */))
const _c3b4e6f0 = () => interopDefault(import('..\\src\\pages\\term.vue' /* webpackChunkName: "pages/term" */))
const _5986732b = () => interopDefault(import('..\\src\\pages\\xml.vue' /* webpackChunkName: "pages/xml" */))
const _01813f2e = () => interopDefault(import('..\\src\\pages\\car\\purchase.vue' /* webpackChunkName: "pages/car/purchase" */))
const _0339677f = () => interopDefault(import('..\\src\\pages\\invoice\\category.vue' /* webpackChunkName: "pages/invoice/category" */))
const _dfdaf5ba = () => interopDefault(import('..\\src\\pages\\invoice\\history.vue' /* webpackChunkName: "pages/invoice/history" */))
const _97f2f840 = () => interopDefault(import('..\\src\\pages\\invoice\\menu.vue' /* webpackChunkName: "pages/invoice/menu" */))
const _6ba916ab = () => interopDefault(import('..\\src\\pages\\mem\\config.vue' /* webpackChunkName: "pages/mem/config" */))
const _1c709852 = () => interopDefault(import('..\\src\\pages\\mem\\employee.vue' /* webpackChunkName: "pages/mem/employee" */))
const _e7debb52 = () => interopDefault(import('..\\src\\pages\\mem\\info.vue' /* webpackChunkName: "pages/mem/info" */))
const _51cb4ad9 = () => interopDefault(import('..\\src\\pages\\payment\\success.vue' /* webpackChunkName: "pages/payment/success" */))
const _3266e9c6 = () => interopDefault(import('..\\src\\pages\\report\\cost.vue' /* webpackChunkName: "pages/report/cost" */))
const _c7e5adcc = () => interopDefault(import('..\\src\\pages\\tool\\report\\index.vue' /* webpackChunkName: "pages/tool/report/index" */))
const _89b6d462 = () => interopDefault(import('..\\src\\pages\\tool\\retire.vue' /* webpackChunkName: "pages/tool/retire" */))
const _202f0e16 = () => interopDefault(import('..\\src\\pages\\tool\\report\\account.vue' /* webpackChunkName: "pages/tool/report/account" */))
const _c32523b8 = () => interopDefault(import('..\\src\\pages\\tool\\report\\balance.vue' /* webpackChunkName: "pages/tool/report/balance" */))
const _0468de0a = () => interopDefault(import('..\\src\\pages\\tool\\report\\debt.vue' /* webpackChunkName: "pages/tool/report/debt" */))
const _5d797048 = () => interopDefault(import('..\\src\\pages\\tool\\report\\history.vue' /* webpackChunkName: "pages/tool/report/history" */))
const _fd1990b6 = () => interopDefault(import('..\\src\\pages\\tool\\report\\year.vue' /* webpackChunkName: "pages/tool/report/year" */))
const _ff8c3134 = () => interopDefault(import('..\\src\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _cb52f05c = () => interopDefault(import('..\\src\\pages\\tool\\report\\_slug.vue' /* webpackChunkName: "pages/tool/report/_slug" */))
const _0dd2717f = () => interopDefault(import('..\\src\\pages\\news\\_id\\_slug.vue' /* webpackChunkName: "pages/news/_id/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _f1a5ac0c,
    name: "about-us"
  }, {
    path: "/admin",
    component: _3c15d882,
    name: "admin"
  }, {
    path: "/car",
    component: _18db131a,
    name: "car"
  }, {
    path: "/guide",
    component: _3497d490,
    name: "guide"
  }, {
    path: "/invoice",
    component: _0b6de7be,
    name: "invoice"
  }, {
    path: "/login",
    component: _49e18a7d,
    name: "login"
  }, {
    path: "/mem",
    component: _7f18d279,
    name: "mem"
  }, {
    path: "/news",
    component: _304ba233,
    name: "news"
  }, {
    path: "/policy",
    component: _87d36d64,
    name: "policy"
  }, {
    path: "/report",
    component: _554b9b9c,
    name: "report"
  }, {
    path: "/term",
    component: _c3b4e6f0,
    name: "term"
  }, {
    path: "/xml",
    component: _5986732b,
    name: "xml"
  }, {
    path: "/car/purchase",
    component: _01813f2e,
    name: "car-purchase"
  }, {
    path: "/invoice/category",
    component: _0339677f,
    name: "invoice-category"
  }, {
    path: "/invoice/history",
    component: _dfdaf5ba,
    name: "invoice-history"
  }, {
    path: "/invoice/menu",
    component: _97f2f840,
    name: "invoice-menu"
  }, {
    path: "/mem/config",
    component: _6ba916ab,
    name: "mem-config"
  }, {
    path: "/mem/employee",
    component: _1c709852,
    name: "mem-employee"
  }, {
    path: "/mem/info",
    component: _e7debb52,
    name: "mem-info"
  }, {
    path: "/payment/success",
    component: _51cb4ad9,
    name: "payment-success"
  }, {
    path: "/report/cost",
    component: _3266e9c6,
    name: "report-cost"
  }, {
    path: "/tool/report",
    component: _c7e5adcc,
    name: "tool-report"
  }, {
    path: "/tool/retire",
    component: _89b6d462,
    name: "tool-retire"
  }, {
    path: "/tool/report/account",
    component: _202f0e16,
    name: "tool-report-account"
  }, {
    path: "/tool/report/balance",
    component: _c32523b8,
    name: "tool-report-balance"
  }, {
    path: "/tool/report/debt",
    component: _0468de0a,
    name: "tool-report-debt"
  }, {
    path: "/tool/report/history",
    component: _5d797048,
    name: "tool-report-history"
  }, {
    path: "/tool/report/year",
    component: _fd1990b6,
    name: "tool-report-year"
  }, {
    path: "/",
    component: _ff8c3134,
    name: "index"
  }, {
    path: "/tool/report/:slug",
    component: _cb52f05c,
    name: "tool-report-slug"
  }, {
    path: "/news/:id/:slug?",
    component: _0dd2717f,
    name: "news-id-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
